export const ProjectName = 'eQUIP';
export const Api_Url = process.env.REACT_APP_API_URL;
export const Dashboard_Video_URL =
  'https://et-equip.s3.amazonaws.com/live/resources/videos/dashboard/convert_dashboard/6.m3u8';
export const Api_Version = process.env.REACT_APP_API_VERSION;

export const feedspace_id_dashboard = 'YGAnStrNEMMUz1yg';
export const feedspace_id_module_handout = 'v8PpqwseyiYaRUGd';

export const CAPTCHA_KEY = process.env.REACT_APP_CAPTCHA_KEY;

export const USER_ROLE = {
  SUPER_ADMIN: 1,
  SCHOOL_ADMIN: 2,
  ADMIN: 5,
  SCHOOL_STAFF: 3,
  DEMO_USER: 4,
};

export const E_THERAPY_HOME_URL = 'https://www.electronic-therapy.com/';

export const track_video_duration = { duration: null };

export const ADMIN_PATH = '/admin';
export const SCHOOL_PATH = '/school';

export const ADMIN_API_PREFIX = '/admin';
export const SCHOOL_ADMIN_API_PREFIX = '/school-admin';
